import React, { useEffect, useMemo, useRef } from 'react';
import { Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-attributes.OverflowMenu');
export default function OverflowMenu({
  popupVariant,
  toggleVariant,
  className,
  visibilityMap,
  onMenuSizeChange,
  children,
  value
}) {
  const toggleRef = useRef();
  const {
    menuCount,
    visibleCount
  } = useMemo(() => Object.values(visibilityMap).reduce((prev, current) => {
    if (current) {
      prev.visibleCount += 1;
    }
    return prev;
  }, {
    menuCount: value?.length || 0,
    visibleCount: 0
  }), [visibilityMap, value]);
  useEffect(() => {
    let observer;
    if (toggleRef.current) {
      const observe = evt => {
        const clientRect = evt[0].target.getBoundingClientRect();
        if (visibleCount !== 0) {
          onMenuSizeChange?.(clientRect.width);
        }
      };
      observer = new ResizeObserver(observe);
      observer.observe(toggleRef.current);
    }
    return () => {
      observer?.disconnect();
    };
  }, [onMenuSizeChange, menuCount, visibleCount]);
  const title = useMemo(() => {
    if (visibleCount === 0) {
      return t('all', {
        count: menuCount
      });
    }
    return t('more', {
      count: menuCount - visibleCount
    });
  }, [menuCount, visibleCount]);
  if (menuCount === visibleCount) {
    return null;
  }
  return /*#__PURE__*/_jsx(Popup, {
    className: className,
    variant: popupVariant,
    toggleVariant: toggleVariant,
    toggleAttributes: {
      domRef: toggleRef
    },
    title: title,
    children: React.Children.map(children, child => {
      if (!visibilityMap[child.props['data-targetid']]) {
        return /*#__PURE__*/_jsx(Popup.Item, {
          disabled: true,
          children: child
        });
      }
      return null;
    })
  });
}